<template>
	<LayoutTabs class="user-profile">
		<template slot="title">User Overview</template>
		<template slot="tabs">
			<span
				class="tab__item"
				:class="{'tab__item--active' : index === active}"
				v-for="(tab, index) in tabs"
				:key="index"
				@click="active = index"
			>
				{{ tab }}
			</span>
		</template>
		<template slot="content">
			<template v-if="active === 0">
				<AppLoading v-if="userLoading"/>
				<template v-else>
					<LayoutDetails>
						<template slot="image">
							<AppImage
								:src="user.image"
								:fallback="require('@/assets/img/default-avatar.png')"
								title="avatar"
							/>
						</template>
						<template slot="title">
							Account Details
						</template>
						<template slot="controls">
							<AppButton modifier="small-warning">Suspend</AppButton>
							<AppButton modifier="small-danger">Delete</AppButton>
						</template>
						<AppInfo label="Name">{{ user.name || '--' }}</AppInfo>
						<div>
							<AppInfo label="Date Joined">{{ user.date_joined | dateFormatter('MMM D, YYYY') }}</AppInfo>
							<AppInfo label="Last Active">{{ user.last_active | dateFormatter('MMM D, YYYY') }}</AppInfo>
						</div>
						<AppInfo label="Email">{{ user.email | null }}</AppInfo>
						<AppInfo label="Username">{{ user.username }}</AppInfo>
						<AppInfo label="Birthday">{{ user.birthday | dateFormatter('MMM D, YYYY') }}</AppInfo>
						<AppInfo label="Age">{{ user.age | null }}</AppInfo>
						<AppInfo label="Gender">{{ user.gender | null }}</AppInfo>
						<AppInfo label="Device">{{ user.device_type | capitalize }}</AppInfo>
					</LayoutDetails>
				</template>
			</template>

			<UserMoodStream
				v-if="active === 1"
				:id="id"
			/>

			<UserSleepData
				v-if="active === 2"
				:id="id"
			/>
		</template>
	</LayoutTabs>
</template>

<script>
import * as userModule from '@/store/user'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import UserMoodStream from '@/components/user/UserMoodStream'
import UserSleepData from '@/components/user/UserSleepData'

export default {
	props: ['id'],

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['user/']) {
			this.$store.registerModule('user', userModule.default)
		}
	},

	beforeRouteLeave (to, from, next) {
		if (to.name !== 'users') {
			this.lastQueryParams = ''
		}

		next()
	},

	created () {
		this.$store.dispatch('user/viewUser', this.id)
	},

	data () {
		return {
			active: 0,
			tabs: ['User Details', 'Mood Stream']
		}
	},

	computed: {
		...mapGetters('user', {
			user: 'getUserView',
			userLoading: 'getUserViewLoading',
			userProfileExcelLoading: 'getUserProfileExcelLoading'
		}),

		...mapGetters({
			modalName: 'modalName'
		}),

		...mapFields('user', {
			calendarDaily: 'calendarDaily',
			calendarDate: 'calendarDate',
			lastQueryParams: 'lastQueryParams'
		})
	},

	components: {
		UserMoodStream,
		UserSleepData
	}
}
</script>
